import React from 'react';
interface BonusItem {
  title: string;
  image: string;
}
const bonuses: BonusItem[] = [{
  title: 'BONO 1 — +10 drills y casuisticas SISTEMA DE PASES INTEGRAL',
  image: 'https://cdn.magicpatterns.com/uploads/bKBSRpgrrDyVRA6efEwzzs/Screenshot_2026-07-07_at_12.12.03_AM.png'
}, {
  title: 'BONO 2 — SISTEMA DE TIROS LIBRES Y AL ARCO INTEGRAL',
  image: 'https://cdn.magicpatterns.com/uploads/2yEaK6Hv9otrB4M1bu53XJ/Screenshot_2026-07-07_at_12.11.42_AM.png'
}, {
  title: "BONO 3 — EL ROL DEL '5' EN 10 FORMACIONES Y CÓMO JUGARLAS",
  image: 'https://cdn.magicpatterns.com/uploads/qhCViLEhxdxZT33SHfAMMS/Screenshot_2026-07-07_at_12.12.36_AM.png'
}, {
  title: 'BONO 4 — VISUALES DE JUGADAS PREPARADAS',
  image: 'https://cdn.magicpatterns.com/uploads/sR9iT3NWobuFCmjuA77rzB/Screenshot_2026-07-07_at_12.11.20_AM.png'
}, {
  title: 'BONO 5 — EJERCICIOS PARA HACER SOLO EN CASA',
  image: 'https://cdn.magicpatterns.com/uploads/8BFYj91p3dDZYBAJff8bQZ/Screenshot_2026-07-07_at_12.12.18_AM.png'
}, {
  title: 'BONO 6 — ENTRENAMIENTO DE 8 SEMANAS',
  image: 'https://cdn.magicpatterns.com/uploads/p7LFW1oC6RnC3SXsT2SXEH/Screenshot_2026-07-07_at_12.13.03_AM.png'
}];
export function BonusCarousel() {
  return <div data-id="element-171" data-mp="31hqa4bk6io32">
      <div aria-label="Carrusel de bonos incluidos" className="-mx-4 flex snap-x snap-mandatory gap-4 overflow-x-auto px-4 pb-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" data-id="element-172" data-mp="31hzt3f6t3uz9">
        {bonuses.map((bonus, index) => <article key={bonus.title} className="relative aspect-[4/5] w-[82vw] max-w-[330px] flex-none snap-center overflow-hidden rounded-2xl border border-green-200 bg-green-950 shadow-lg" data-id="element-173" data-mp="3u3sv3mka35kz" data-mpi={index}>
            <img src={bonus.image} alt={`Vista previa: ${bonus.title}`} className="h-full w-full object-cover object-top" data-id="element-174" data-mp="2drdx4ma2u15m" />
            <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-green-950 via-green-950/70 to-transparent" data-id="element-175" data-mp="28uvrlk6x9ys8" />
            <div className="absolute inset-x-0 bottom-0 p-5 text-white" data-id="element-176" data-mp="14v77u6fv4h20">
              <p className="mb-2 text-xs font-black tracking-[0.18em] text-green-300" data-id="element-177" data-mp="quwhr5mdn6hw">
                BONO GRATIS {index + 1}
              </p>
              <h4 className="text-lg font-black leading-tight" data-id="element-178" data-mp="vsy2duzgbdvh">
                {bonus.title}
              </h4>
            </div>
          </article>)}
      </div>
      <p className="mt-1 text-center text-xs font-semibold text-gray-500" data-id="element-179" data-mp="lvl07ue6rwz9">
        Desliza para ver los 6 bonos incluidos →
      </p>
    </div>;
}